import { Navigate, Outlet, useLocation } from 'react-router';
import { Loader2 } from 'lucide-react';
import { useSession } from './session';
import { ErrorState } from '@/components/states';

export function RequireAuth() {
  const { session, loading, error } = useSession();
  const location = useLocation();
  if (loading) {
    return (
      <div className="flex min-h-svh items-center justify-center" role="status" aria-live="polite">
        <Loader2 className="text-muted-foreground size-6 animate-spin" />
        <span className="sr-only">Carregando sessão…</span>
      </div>
    );
  }
  if (error && !session) return <ErrorState error={error} className="min-h-svh" />;
  if (!session) {
    const next = `${location.pathname}${location.search}`;
    return <Navigate to={`/entrar?next=${encodeURIComponent(next)}`} replace />;
  }
  // Senha provisória: a única tela liberada é a de troca de senha.
  if (session.user.mustChangePassword && location.pathname !== '/trocar-senha') return <Navigate to="/trocar-senha" replace />;
  if (!session.user.mustChangePassword && location.pathname === '/trocar-senha') return <Navigate to="/" replace />;
  return <Outlet />;
}
